<template>
  <div v-if="selectedGoalsArray.length > 0" class="selected-goals-areas">
    <span v-if="readonly" class="gray-chip">
      Metas Académicas Relacionada(s)
    </span>
    <div class="py-2">
      <div
        v-for="(goal, indexGoal) in selectedGoalsArray"
        :key="`reason-item-${indexGoal}`"
        class="reason-item px-3 d-inline-block mr-2 mb-2"
      >
        <span class="color-black font-16">
          {{ goal.name }}
        </span>
        <span class="color-black font-16 font-weight-bold">
          {{ goal.area }}
        </span>
        <i
          v-if="!readonly"
          class="far fa-times-circle text-red font-16 cursor-pointer ml-2"
          @click="onDeleteItemHandler(indexGoal)"
        />
      </div>
      <div class="dropdown-divider mt-0 pb-2 ml-3 mt-3 mb-1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectedGoalsAreas',
  props: {
    selectedGoals: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    selectedGoalsArray() {
      if (
        !this.selectedGoals ||
        !this.selectedGoals.goalSelection ||
        this.selectedGoals.goalSelection.length === 0
      ) {
        return [];
      }
      return this.selectedGoals.goalSelection.map((goal) => {
        return {
          name: goal.name,
          area: goal.areaName ? ` [${goal.areaName}]` : '',
        };
      });
    },
  },
  methods: {
    onDeleteItemHandler(index) {
      this.selectedGoals.goalSelection.splice(index, 1);
      this.$emit('save-goal-selection', this.selectedGoals.goalSelection);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.selected-goals-areas {
  margin-top: -0.2rem;
  padding: 1rem;
  padding-top: 0;
  padding-left: 1.7rem;
  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }
}

.gray-chip {
  background-color: #b5c3bc;
  border: 1px solid #b5c3bc;
  border-radius: 15px;
  color: white;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;
  margin-right: 24px;
  padding: 0 15px;
  width: fit-content;
}
.reason-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
  font-size: 90%;
}
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
